const announcements = [
    {
        title: "Dependețe care duc viața în ruină",
        description: "Alătură-te nouă pentru a petrece o seară în prezența lui Dumnezeu, sau poate pentru a-L cunoaște pentru prima oară. Vino așa cum eșți, dar nu-ți putem garanta că vei pleca la fel 😊. Vom avea ca invitat pe Daniel Perijoc, și de asemenea ai ocazia să cunoști persoane noi ✨, iubitoare ❤️, din tot județul 🗺️. P.S: la final... 🍔🥪☕🥤",
        location: "Biserica Maranata, Lupeni ⛪",
        dateTime: "16.03.2024, ora 17:00"
    }
]

export default announcements
